import { render, staticRenderFns } from "./CostCard.vue?vue&type=template&id=541c1e88"
import script from "./CostCard.vue?vue&type=script&lang=js"
export * from "./CostCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports